import React from 'react';
import { useSearchParams } from 'react-router-dom';

interface EmbeddableViewProps {
  children: React.ReactNode;
}

/**
 * EmbeddableView is a wrapper component for sections that can be embedded in iframes.
 * It doesn't include the sidebar or other navigation elements.
 * It can optionally have a themed header based on URL parameters.
 */
const EmbeddableView: React.FC<EmbeddableViewProps> = ({ children }) => {
  const [searchParams] = useSearchParams();
  
  // Parse optional parameters from URL
  const showHeader = searchParams.get('header') === 'true';
  const headerTitle = searchParams.get('title') || '';
  const headerColor = searchParams.get('color') || 'blue';
  const theme = searchParams.get('theme') || 'light';
  
  // Determine theme class
  const themeClass = theme === 'dark' ? 'bg-gray-900 text-white' : 'bg-white text-gray-900';
  
  return (
    <div className={`min-h-screen ${themeClass}`}>
      {showHeader && (
        <header className={`p-4 bg-${headerColor}-500 text-white`}>
          <div className="container mx-auto flex items-center justify-between">
            <h1 className="text-xl font-bold">{headerTitle}</h1>
            <div className="flex items-center space-x-2">
              <img src="/scanalytics-logo.png" alt="Scanalytics" className="h-8" />
            </div>
          </div>
        </header>
      )}
      
      <main className="container mx-auto p-4">
        {children}
      </main>
    </div>
  );
};

export default EmbeddableView; 